import React, { Component } from 'react';

import "./Header.scss"

import AppMenu from "./components/Header-Menu/Header-Menu"

import data from "../../api/data.json"

import isralogo from "../../static/images/isralogo.png"
import pblogo from "../../static/images/pblogo.png"

import fbIcon from "../../static/images/facebook.png"
import twtIcon from "../../static/images/twitter.png"
import wsIcon from "../../static/images/mobile/whatsapp.png"
import nsIcon from "../../static/images/nagish.png"
import hum from "../../static/images/mobile/menu.png"

import { Link } from 'react-router-dom'

class Header extends Component {
  constructor() {
    super();
    this.shareBTN = this.shareBTN.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.state = {
      isActive: 0,
      menuActive: 0,
      menu: "hamburger",
      isralogo: {
        backgroundImage: "url(" + isralogo + ")"
      },
      pblogo: {
        backgroundImage: "url(" + pblogo + ")"
      },
      shareButton: {
        twitter: {
          backgroundImage: "url(" + twtIcon + ")"
        },
        facebook: {
          backgroundImage: "url(" + fbIcon + ")"
        },
        whatsapp: {
          backgroundImage: "url(" + wsIcon + ")"
        },
        negishut: {
          backgroundImage: "url(" + nsIcon + ")"
        },
        hamburger: {
          backgroundImage: "url(" + hum + ")"
        }
      }
    }
  }
  shareBTN(action) {
    var url = "https://z.ynet.co.il/short/commerce/2017/isracard/";
    switch (action) {
      default:
      case "facebook":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'isracard',
          'Action': 'Share_Facebook',
          'Label': window.location.href
        });
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'isracard',
          'Action': 'Share_Twitter',
          'Label': window.location.href
        });
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'isracard',
          'Action': 'Share_WhatsApp',
          'Label': window.location.href
        });
        window.open("whatsapp://send?text=" + encodeURIComponent(window.document.title + " >> https://z.ynet.co.il/short/commerce/2017/isracard/"), "_parent");
        break;
      case "negishut":
        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        break;
      case "hamburger":
        this.setState({
          menu: (this.state.menu === "hamburger" ? "hamburger active" : "hamburger"),
          menuActive: (this.state.menuActive === 0 ? 1 : 0)
        });
        break;
      case "sharer":
        this.setState({
          isActive: (this.state.isActive === 1 ? 0 : 1)
        });
        break;
    }
  }
  goHomepage() {
    window.dataLayer.push({
      'event': 'virtualPageview',
      'virtualPageURL': "/#/",
      'virtualPageTitle': "ynet - איך קונים ברשת?"
    });
  }
  closeMenu() {
    this.setState({
      menu: "hamburger",
      menuActive: 0
    })
  }
  render() {
    const isActiveIcon = (this.state.isActive === 0 ? "" : " active");
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="rightside">
              <div style={this.state.isralogo} className="isralogo"></div>
              <div style={this.state.pblogo} className="pblogo"></div>
            </div>
            <div className="leftside">
              <div onClick={() => { this.shareBTN("whatsapp") }} style={this.state.shareButton.whatsapp} className={"share ws " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("twitter") }} style={this.state.shareButton.twitter} className={"share twitter"}></div>
              <div onClick={() => { this.shareBTN("facebook") }} style={this.state.shareButton.facebook} className={"share fb " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("negishut") }} style={this.state.shareButton.negishut} className="share negishut"></div>
              <div onClick={() => { this.shareBTN("sharer") }} className={"share sharer " + isActiveIcon}></div>
              <div id="menu" className={this.state.menu} onClick={() => { this.shareBTN("hamburger") }}>
                <div className="hamburger line"></div>
                <div className="hamburger line middle"></div>
                <div className="hamburger line"></div>
              </div>
            </div>
            <div className="middlelogo">
              <Link to="/" onClick={this.goHomepage}>
                <div className="logo"></div>
              </Link>
            </div>
            <div className="leftback">
              <Link to="/" onClick={this.goHomepage}>
                <div className="logo"></div>
              </Link>
            </div>
          </div>
        </div>
        <menu>
          <AppMenu scrollFromMenu={this.props.scrollFromMenu} menuActive={this.state.menuActive} closeMenu={this.closeMenu} menuItems={data.header} />
        </menu>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js